import { render, staticRenderFns } from "./effectDetailStore.vue?vue&type=template&id=47a3c051&scoped=true"
import script from "./effectDetailStore.vue?vue&type=script&lang=js"
export * from "./effectDetailStore.vue?vue&type=script&lang=js"
import style0 from "./effectDetailStore.vue?vue&type=style&index=0&id=47a3c051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a3c051",
  null
  
)

export default component.exports